if (typeof window !== 'undefined') {
	window.FS = window.FS || {};
	window['utag_data'] = window['utag_data'] || {};
}
export const triggerEvent = (type, action, payload?, thisArg?, extraData?) => {
	if (thisArg) {
		window.FS?.['Tealium']?.trackInteraction(type, action, payload, thisArg, extraData);
	} else {
		window.FS?.['Tealium']?.trackInteraction(type, action, payload, undefined, extraData);
	}
};

const inheritedProperties = [
	'aa_account',
	'site_prefix',
	'site_template',
	'page_url',
	'aem_url',
	'page_language',
	'property_name',
	'property_code',
	'property_region',
	'property_subregion',
	'page_detail',
	'golden_id',
	'login_state',
];

export const triggerPageView = data => {
	//copy initial fields from global utag_data
	const inheritedPageData = {};
	if (window['utag_data']) {
		inheritedProperties.forEach(trackingProp => {
			if (window['utag_data']?.[trackingProp]) {
				inheritedPageData[trackingProp] = window['utag_data']?.[trackingProp];
			}
		});
	}
	window.FS?.['Tealium']?.trackPage(Object.assign({}, inheritedPageData, data));
};

export const triggerLinkView = (eventName: string, data, uid?: string) => {
	//copy initial fields from global utag_data
	const inheritedPageData = {};
	if (window['utag_data']) {
		[...inheritedProperties, 'page_name', 'page_section'].forEach(trackingProp => {
			if (window['utag_data']?.[trackingProp]) {
				inheritedPageData[trackingProp] = window['utag_data']?.[trackingProp];
			}
		});
	}
	window.FS?.['Tealium']?.trackLink(eventName, Object.assign({}, inheritedPageData, data), uid);
};

export function attachYouTubeAnalyticsEvents(event) {
	window.FS?.['Tealium']?.onYouTubePlayerReady(event);
}

const events: { parentElement: Element; eventName: string; eventData }[] = [];
export const trackClickUsingCapture = (parentElements, eventName, eventData) => {
	// setup the capture event the first time called
	if (events.length === 0) {
		document.addEventListener('click', trackClick, true);
	}
	if (parentElements && eventName) {
		eventData = eventData || {};
		parentElements = Array.isArray(parentElements) ? parentElements : [parentElements];
		parentElements.forEach(parentElement => {
			events.push({ parentElement, eventName, eventData });
		});
	}
};

const trackClick = (e: MouseEvent) => {
	events.forEach(({ parentElement, eventName, eventData }) => {
		if (
			parentElement.contains(e.target as Element) &&
			(e.target as Element)?.getAttribute('href')
		) {
			triggerLinkView(eventName, eventData);
			if (document.cookie.includes('utagdb=true')) {
				console.log('tracking click', eventName, eventData ? JSON.stringify(eventData) : '');
			}
		}
	});
};

export const campaignTrackChildren = (parentElements, campaignValue) => {
	if (parentElements && campaignValue) {
		campaignValue = campaignValue.includes('_s_icmp') ? campaignValue : `_s_icmp=${campaignValue}`;
		campaignValue = campaignValue.replace(/\s/g, '_');
		parentElements = parentElements.forEach instanceof Function ? parentElements : [parentElements];
		parentElements.forEach(parentElement => {
			const links = parentElement.querySelectorAll('[href]');
			links.forEach(link => {
				try {
					let href = link.getAttribute('href');
					href = href + (href.includes('?') ? `&${campaignValue}` : `?${campaignValue}`);
					link.setAttribute('href', href);
				} catch (e) {
					//empty by design
				}
			});
		});
	}
};
